import { hideElement, showElement } from "@grindex-common/helpers/domManipulation";

export default class FindALocationDropDown {
	constructor(selector) {
		this._$element = document.querySelector(selector);

		if (this._$element) {
			this.domElementExists = true;
			this.defaultIndex = this._$element.selectedIndex;
		} else {
			this.domElementExists = false;
		}
	}

	text() {
		return this.exists() && this._$element.selectedIndex >= 0 ? this._$element.options[this._$element.selectedIndex].text : null;
	}

	value() {
		return this.exists() && this._$element.selectedIndex >= 0 ? this._$element.options[this._$element.selectedIndex].value : null;
	}

	isOnOption(option) {
		return this.exists() && this._$element.selectedIndex === option;
	}

	isNotDefaultValue() {
		return this.exists() && this.defaultIndex !== this._$element.selectedIndex;
	}

	isDefaultValue() {
		return !this.isNotDefaultValue();
	}

	hide() {
		if (this.exists()) {
			hideElement(this._$element.parentElement);
		}
	}

	show() {
		if (this.exists()) {
			showElement(this._$element.parentElement);
		}
	}

	isHidden() {
		return (this.exists() && this._$element.classList.contains("hidden")) || this._$element.style.display === "none";
	}

	domElement() {
		return this._$element;
	}

	listenTo(event, callBack) {
		if (this.exists()) {
			this._$element.addEventListener(event, callBack);
		}
	}

	clear() {
		if (this.exists()) {
			this._$element.innerHTML = "";
		}
	}

	reset() {
		if (this.exists()) {
			this._$element.selectedIndex = this.defaultIndex;
		}
	}

	exists() {
		return this.domElementExists;
	}

	populate(data, clearAllButFirst) {
		if (this.exists()) {
			const $firstChild = this._$element.firstChild;

			this._$element.innerHTML = "";

			if (clearAllButFirst) {
				this._$element.append($firstChild);
			}

			if (data) {
				data.forEach((value) => {
					const option = document.createElement("option");
					option.value = value;
					option.innerHTML = value;
					this._$element.append(option);
				});
			}
		}
	}
}
